
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue?macro=true";
import { default as indexCkIMXr03vy0s7HoTclSmlEfrzCO4RsZ3Jw0jTR6qpfMMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue?macro=true";
import { default as indexozoSdltwk9VaiURIq_H8eri8uxjXRGv8fs_45NBm4z6TUMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue?macro=true";
import { default as indexNMH25I75Dowsds_45si15tO_45oQ1KCY2MtXLXHFb57sWpIMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue?macro=true";
import { default as _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue?macro=true";
import { default as indexGKUToVZyYl5SW8x_ZxtUF_1E8OsN32xi1RvJ2i21RF4Meta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue?macro=true";
import { default as indexctGCRzBedT_WcboV3kIq54ogWOVeXuAruc3sYYqdUsEMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue?macro=true";
import { default as ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue?macro=true";
import { default as ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue?macro=true";
import { default as indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue?macro=true";
import { default as indexf7YD7xLTjwOX_45pderCJ32rH6fuxAFcZhVgqxm8sJK2IMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue?macro=true";
import { default as indexR5EQmoWqhA5qBtCNXIV64Si_455N306eTkMY7UIiHzfmIMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue?macro=true";
import { default as indexlV7emz5Tz73UvyOK2tROx1tFKVFrb6gvhxydCPNvFwIMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue?macro=true";
import { default as indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue?macro=true";
import { default as indexIuxxEN4C2PWNQc7x9u_45gKCtiUiFpgEOJj8qmJWx2_X8Meta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue?macro=true";
import { default as indexN3YktsUKRG0qWa7If7CJISvWw_45UHeGgNewd5gpMWFgAMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue?macro=true";
import { default as lazyTextNWQZ2uoAWiEYLVX1H_45adB8SxeXR3xMq9zSHoEqNUm34Meta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts?macro=true";
import { default as index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue?macro=true";
import { default as lazyRenderrHZFcn7Hx5SZbcpJH4EFIkJiWeCUNCaMHX_45oT3LPMZcMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts?macro=true";
import { default as indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue?macro=true";
import { default as _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue?macro=true";
import { default as indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue?macro=true";
import { default as indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue?macro=true";
import { default as indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue?macro=true";
import { default as indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue?macro=true";
import { default as indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue?macro=true";
import { default as index5PtD6Ve88tnxdDSCOcfM_45uKfSeO_gguGdq59uHnV2uEMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue?macro=true";
import { default as indexg_45JjXYqTSBv1NekpinxD6daCMc0wwDl5YaMz_HwAB3gMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue?macro=true";
import { default as indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue?macro=true";
import { default as indexGUDBByu1G2Nwl7myM6gmjXg4aVy01nU3IEws0jJZ1IQMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue?macro=true";
import { default as component_45stubiiiJrQBLGxxGHDOi66Il30kHzvpvzbDFFkCVYpVjKWgMeta } from "/var/jenkins_home/workspace/pdf_web_biz_cn/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubiiiJrQBLGxxGHDOi66Il30kHzvpvzbDFFkCVYpVjKWg } from "/var/jenkins_home/workspace/pdf_web_biz_cn/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "pro___en",
    path: "/en/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue")
  },
  {
    name: "pro___zh",
    path: "/zh/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue")
  },
  {
    name: "pro___ja",
    path: "/ja/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue")
  },
  {
    name: "pro___zh-TW",
    path: "/zh-TW/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue")
  },
  {
    name: "pro___ko",
    path: "/ko/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue")
  },
  {
    name: "pro___hi",
    path: "/hi/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue")
  },
  {
    name: "pro___de",
    path: "/de/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue")
  },
  {
    name: "pro___ar",
    path: "/ar/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue")
  },
  {
    name: "pro___fr",
    path: "/fr/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue")
  },
  {
    name: "pro___id",
    path: "/id/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue")
  },
  {
    name: "pro___itb",
    path: "/itb/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue")
  },
  {
    name: "pro___uk",
    path: "/uk/pro",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/pro/index.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue")
  },
  {
    name: "blog___zh",
    path: "/zh/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue")
  },
  {
    name: "blog___ja",
    path: "/ja/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue")
  },
  {
    name: "blog___zh-TW",
    path: "/zh-TW/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue")
  },
  {
    name: "blog___ko",
    path: "/ko/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue")
  },
  {
    name: "blog___hi",
    path: "/hi/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue")
  },
  {
    name: "blog___ar",
    path: "/ar/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue")
  },
  {
    name: "blog___id",
    path: "/id/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue")
  },
  {
    name: "blog___itb",
    path: "/itb/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue")
  },
  {
    name: "blog___uk",
    path: "/uk/blog",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/blog/index.vue")
  },
  {
    name: "home___en",
    path: "/en/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue")
  },
  {
    name: "home___zh",
    path: "/zh/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue")
  },
  {
    name: "home___ja",
    path: "/ja/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue")
  },
  {
    name: "home___zh-TW",
    path: "/zh-TW/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue")
  },
  {
    name: "home___ko",
    path: "/ko/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue")
  },
  {
    name: "home___hi",
    path: "/hi/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue")
  },
  {
    name: "home___de",
    path: "/de/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue")
  },
  {
    name: "home___ar",
    path: "/ar/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue")
  },
  {
    name: "home___fr",
    path: "/fr/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue")
  },
  {
    name: "home___id",
    path: "/id/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue")
  },
  {
    name: "home___itb",
    path: "/itb/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue")
  },
  {
    name: "home___uk",
    path: "/uk/home",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "index___zh",
    path: "/zh",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "index___zh-TW",
    path: "/zh-TW",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "index___hi",
    path: "/hi",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "index___itb",
    path: "/itb",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    meta: indexZUfLAPe26Gspo5Nlsl_oM3Ne2w0aX7PQuKur5W2o2vAMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/index/index.vue")
  },
  {
    name: "join-token___en",
    path: "/en/join/:token()",
    meta: _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue")
  },
  {
    name: "join-token___zh",
    path: "/zh/join/:token()",
    meta: _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue")
  },
  {
    name: "join-token___ja",
    path: "/ja/join/:token()",
    meta: _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue")
  },
  {
    name: "join-token___zh-TW",
    path: "/zh-TW/join/:token()",
    meta: _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue")
  },
  {
    name: "join-token___ko",
    path: "/ko/join/:token()",
    meta: _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue")
  },
  {
    name: "join-token___hi",
    path: "/hi/join/:token()",
    meta: _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue")
  },
  {
    name: "join-token___de",
    path: "/de/join/:token()",
    meta: _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue")
  },
  {
    name: "join-token___ar",
    path: "/ar/join/:token()",
    meta: _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue")
  },
  {
    name: "join-token___fr",
    path: "/fr/join/:token()",
    meta: _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue")
  },
  {
    name: "join-token___id",
    path: "/id/join/:token()",
    meta: _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue")
  },
  {
    name: "join-token___itb",
    path: "/itb/join/:token()",
    meta: _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue")
  },
  {
    name: "join-token___uk",
    path: "/uk/join/:token()",
    meta: _91token_93DNETQ_h2A7mEW0_jNKBIWnpIGt9P3dszO3cAmlbj_45Y8Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/join/[token].vue")
  },
  {
    name: "download___en",
    path: "/en/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue")
  },
  {
    name: "download___zh",
    path: "/zh/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue")
  },
  {
    name: "download___ja",
    path: "/ja/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue")
  },
  {
    name: "download___zh-TW",
    path: "/zh-TW/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue")
  },
  {
    name: "download___ko",
    path: "/ko/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue")
  },
  {
    name: "download___hi",
    path: "/hi/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue")
  },
  {
    name: "download___de",
    path: "/de/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue")
  },
  {
    name: "download___ar",
    path: "/ar/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue")
  },
  {
    name: "download___fr",
    path: "/fr/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue")
  },
  {
    name: "download___id",
    path: "/id/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue")
  },
  {
    name: "download___itb",
    path: "/itb/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue")
  },
  {
    name: "download___uk",
    path: "/uk/download",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/download/index.vue")
  },
  {
    name: "translate___en",
    path: "/en/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue")
  },
  {
    name: "translate___zh",
    path: "/zh/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue")
  },
  {
    name: "translate___ja",
    path: "/ja/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue")
  },
  {
    name: "translate___zh-TW",
    path: "/zh-TW/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue")
  },
  {
    name: "translate___ko",
    path: "/ko/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue")
  },
  {
    name: "translate___hi",
    path: "/hi/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue")
  },
  {
    name: "translate___de",
    path: "/de/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue")
  },
  {
    name: "translate___ar",
    path: "/ar/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue")
  },
  {
    name: "translate___fr",
    path: "/fr/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue")
  },
  {
    name: "translate___id",
    path: "/id/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue")
  },
  {
    name: "translate___itb",
    path: "/itb/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue")
  },
  {
    name: "translate___uk",
    path: "/uk/translate",
    meta: {"middleware":[]},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/translate/index.vue")
  },
  {
    name: "home-ImageResult___en",
    path: "/en/home/ImageResult",
    meta: ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___zh",
    path: "/zh/home/ImageResult",
    meta: ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___ja",
    path: "/ja/home/ImageResult",
    meta: ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___zh-TW",
    path: "/zh-TW/home/ImageResult",
    meta: ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___ko",
    path: "/ko/home/ImageResult",
    meta: ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___hi",
    path: "/hi/home/ImageResult",
    meta: ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___de",
    path: "/de/home/ImageResult",
    meta: ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___ar",
    path: "/ar/home/ImageResult",
    meta: ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___fr",
    path: "/fr/home/ImageResult",
    meta: ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___id",
    path: "/id/home/ImageResult",
    meta: ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___itb",
    path: "/itb/home/ImageResult",
    meta: ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue")
  },
  {
    name: "home-ImageResult___uk",
    path: "/uk/home/ImageResult",
    meta: ImageResultoAXd88VyR8uMKwy0t5HnF7D3qOVsJ2_451nwfNtABMQG0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageResult.vue")
  },
  {
    name: "home-ReadMarkdown___en",
    path: "/en/home/ReadMarkdown",
    meta: ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___zh",
    path: "/zh/home/ReadMarkdown",
    meta: ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___ja",
    path: "/ja/home/ReadMarkdown",
    meta: ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___zh-TW",
    path: "/zh-TW/home/ReadMarkdown",
    meta: ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___ko",
    path: "/ko/home/ReadMarkdown",
    meta: ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___hi",
    path: "/hi/home/ReadMarkdown",
    meta: ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___de",
    path: "/de/home/ReadMarkdown",
    meta: ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___ar",
    path: "/ar/home/ReadMarkdown",
    meta: ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___fr",
    path: "/fr/home/ReadMarkdown",
    meta: ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___id",
    path: "/id/home/ReadMarkdown",
    meta: ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___itb",
    path: "/itb/home/ReadMarkdown",
    meta: ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue")
  },
  {
    name: "home-ReadMarkdown___uk",
    path: "/uk/home/ReadMarkdown",
    meta: ReadMarkdownJK2PQbgFCFPwI44AKvr_45yFmeOWN2Y859iw5sWFCFRZgMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ReadMarkdown.vue")
  },
  {
    name: "maintenance___en",
    path: "/en/maintenance",
    meta: indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___zh",
    path: "/zh/maintenance",
    meta: indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___ja",
    path: "/ja/maintenance",
    meta: indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___zh-TW",
    path: "/zh-TW/maintenance",
    meta: indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___ko",
    path: "/ko/maintenance",
    meta: indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___hi",
    path: "/hi/maintenance",
    meta: indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___de",
    path: "/de/maintenance",
    meta: indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___ar",
    path: "/ar/maintenance",
    meta: indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___fr",
    path: "/fr/maintenance",
    meta: indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___id",
    path: "/id/maintenance",
    meta: indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___itb",
    path: "/itb/maintenance",
    meta: indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue")
  },
  {
    name: "maintenance___uk",
    path: "/uk/maintenance",
    meta: indexYktyW0EltPj5CPrJSm9wJ8MOsjesv9N6r45F8Huc2ecMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/maintenance/index.vue")
  },
  {
    name: "home-preview___en",
    path: "/en/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___zh",
    path: "/zh/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___ja",
    path: "/ja/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___zh-TW",
    path: "/zh-TW/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___ko",
    path: "/ko/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___hi",
    path: "/hi/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___de",
    path: "/de/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___ar",
    path: "/ar/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___fr",
    path: "/fr/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___id",
    path: "/id/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___itb",
    path: "/itb/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue")
  },
  {
    name: "home-preview___uk",
    path: "/uk/home/preview",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/index.vue")
  },
  {
    name: "introduction___en",
    path: "/en/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue")
  },
  {
    name: "introduction___zh",
    path: "/zh/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue")
  },
  {
    name: "introduction___ja",
    path: "/ja/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue")
  },
  {
    name: "introduction___zh-TW",
    path: "/zh-TW/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue")
  },
  {
    name: "introduction___ko",
    path: "/ko/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue")
  },
  {
    name: "introduction___hi",
    path: "/hi/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue")
  },
  {
    name: "introduction___de",
    path: "/de/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue")
  },
  {
    name: "introduction___ar",
    path: "/ar/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue")
  },
  {
    name: "introduction___fr",
    path: "/fr/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue")
  },
  {
    name: "introduction___id",
    path: "/id/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue")
  },
  {
    name: "introduction___itb",
    path: "/itb/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue")
  },
  {
    name: "introduction___uk",
    path: "/uk/introduction",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/introduction/index.vue")
  },
  {
    name: "login-forget___en",
    path: "/en/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___zh",
    path: "/zh/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___ja",
    path: "/ja/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___zh-TW",
    path: "/zh-TW/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___ko",
    path: "/ko/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___hi",
    path: "/hi/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___de",
    path: "/de/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___ar",
    path: "/ar/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___fr",
    path: "/fr/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___id",
    path: "/id/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___itb",
    path: "/itb/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue")
  },
  {
    name: "login-forget___uk",
    path: "/uk/login/forget",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/login/forget/index.vue")
  },
  {
    name: "account-index___en",
    path: "/en/account",
    meta: indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue")
  },
  {
    name: "account-index___zh",
    path: "/zh/account",
    meta: indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue")
  },
  {
    name: "account-index___ja",
    path: "/ja/account",
    meta: indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue")
  },
  {
    name: "account-index___zh-TW",
    path: "/zh-TW/account",
    meta: indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue")
  },
  {
    name: "account-index___ko",
    path: "/ko/account",
    meta: indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue")
  },
  {
    name: "account-index___hi",
    path: "/hi/account",
    meta: indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue")
  },
  {
    name: "account-index___de",
    path: "/de/account",
    meta: indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue")
  },
  {
    name: "account-index___ar",
    path: "/ar/account",
    meta: indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue")
  },
  {
    name: "account-index___fr",
    path: "/fr/account",
    meta: indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue")
  },
  {
    name: "account-index___id",
    path: "/id/account",
    meta: indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue")
  },
  {
    name: "account-index___itb",
    path: "/itb/account",
    meta: indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue")
  },
  {
    name: "account-index___uk",
    path: "/uk/account",
    meta: indexDmVxNjTp3vrYOnXUQooQjvKn_45UzQOomS_45RxGppHrrHQMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/index/index.vue")
  },
  {
    name: "versionRecord___en",
    path: "/en/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___zh",
    path: "/zh/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___ja",
    path: "/ja/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___zh-TW",
    path: "/zh-TW/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___ko",
    path: "/ko/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___hi",
    path: "/hi/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___de",
    path: "/de/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___ar",
    path: "/ar/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___fr",
    path: "/fr/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___id",
    path: "/id/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___itb",
    path: "/itb/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue")
  },
  {
    name: "versionRecord___uk",
    path: "/uk/versionRecord",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/versionRecord/index.vue")
  },
  {
    name: "browserUpgrade___en",
    path: "/en/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___zh",
    path: "/zh/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___ja",
    path: "/ja/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___zh-TW",
    path: "/zh-TW/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___ko",
    path: "/ko/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___hi",
    path: "/hi/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___de",
    path: "/de/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___ar",
    path: "/ar/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___fr",
    path: "/fr/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___id",
    path: "/id/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___itb",
    path: "/itb/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue")
  },
  {
    name: "browserUpgrade___uk",
    path: "/uk/browserUpgrade",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/browserUpgrade/index.vue")
  },
  {
    name: "home-preview-lazyText___en",
    path: "/en/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___zh",
    path: "/zh/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___ja",
    path: "/ja/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___zh-TW",
    path: "/zh-TW/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___ko",
    path: "/ko/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___hi",
    path: "/hi/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___de",
    path: "/de/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___ar",
    path: "/ar/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___fr",
    path: "/fr/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___id",
    path: "/id/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___itb",
    path: "/itb/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-preview-lazyText___uk",
    path: "/uk/home/preview/lazyText",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyText.ts")
  },
  {
    name: "home-AIProofread___en",
    path: "/en/home/AIProofread",
    meta: index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___zh",
    path: "/zh/home/AIProofread",
    meta: index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___ja",
    path: "/ja/home/AIProofread",
    meta: index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___zh-TW",
    path: "/zh-TW/home/AIProofread",
    meta: index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___ko",
    path: "/ko/home/AIProofread",
    meta: index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___hi",
    path: "/hi/home/AIProofread",
    meta: index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___de",
    path: "/de/home/AIProofread",
    meta: index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___ar",
    path: "/ar/home/AIProofread",
    meta: index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___fr",
    path: "/fr/home/AIProofread",
    meta: index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___id",
    path: "/id/home/AIProofread",
    meta: index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___itb",
    path: "/itb/home/AIProofread",
    meta: index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-AIProofread___uk",
    path: "/uk/home/AIProofread",
    meta: index4n34vBMyDQUNjYyhLsgcQEOryrxg8TAK9DeN31B3vxEMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/AIProofread/index.vue")
  },
  {
    name: "home-preview-lazyRender___en",
    path: "/en/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___zh",
    path: "/zh/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___ja",
    path: "/ja/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___zh-TW",
    path: "/zh-TW/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___ko",
    path: "/ko/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___hi",
    path: "/hi/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___de",
    path: "/de/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___ar",
    path: "/ar/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___fr",
    path: "/fr/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___id",
    path: "/id/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___itb",
    path: "/itb/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-preview-lazyRender___uk",
    path: "/uk/home/preview/lazyRender",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/preview/lazyRender.ts")
  },
  {
    name: "home-PDFTranslate___en",
    path: "/en/home/PDFTranslate",
    meta: indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___zh",
    path: "/zh/home/PDFTranslate",
    meta: indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___ja",
    path: "/ja/home/PDFTranslate",
    meta: indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___zh-TW",
    path: "/zh-TW/home/PDFTranslate",
    meta: indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___ko",
    path: "/ko/home/PDFTranslate",
    meta: indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___hi",
    path: "/hi/home/PDFTranslate",
    meta: indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___de",
    path: "/de/home/PDFTranslate",
    meta: indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___ar",
    path: "/ar/home/PDFTranslate",
    meta: indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___fr",
    path: "/fr/home/PDFTranslate",
    meta: indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___id",
    path: "/id/home/PDFTranslate",
    meta: indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___itb",
    path: "/itb/home/PDFTranslate",
    meta: indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "home-PDFTranslate___uk",
    path: "/uk/home/PDFTranslate",
    meta: indexkiXo0l1tc5V7U_45V76AHrgUTpylXs9ocWdAXj8NmL1n4Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PDFTranslate/index.vue")
  },
  {
    name: "account-agreement-type___en",
    path: "/en/account/agreement/:type()",
    meta: _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___zh",
    path: "/zh/account/agreement/:type()",
    meta: _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___ja",
    path: "/ja/account/agreement/:type()",
    meta: _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___zh-TW",
    path: "/zh-TW/account/agreement/:type()",
    meta: _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___ko",
    path: "/ko/account/agreement/:type()",
    meta: _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___hi",
    path: "/hi/account/agreement/:type()",
    meta: _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___de",
    path: "/de/account/agreement/:type()",
    meta: _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___ar",
    path: "/ar/account/agreement/:type()",
    meta: _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___fr",
    path: "/fr/account/agreement/:type()",
    meta: _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___id",
    path: "/id/account/agreement/:type()",
    meta: _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___itb",
    path: "/itb/account/agreement/:type()",
    meta: _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue")
  },
  {
    name: "account-agreement-type___uk",
    path: "/uk/account/agreement/:type()",
    meta: _91type_93Wpy0DJY28KHucIkumo_459K_9gRVw_Tuqs5mbh4MQIMncMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/agreement/[type].vue")
  },
  {
    name: "home-PPTXTranslate___en",
    path: "/en/home/PPTXTranslate",
    meta: indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___zh",
    path: "/zh/home/PPTXTranslate",
    meta: indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___ja",
    path: "/ja/home/PPTXTranslate",
    meta: indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___zh-TW",
    path: "/zh-TW/home/PPTXTranslate",
    meta: indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___ko",
    path: "/ko/home/PPTXTranslate",
    meta: indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___hi",
    path: "/hi/home/PPTXTranslate",
    meta: indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___de",
    path: "/de/home/PPTXTranslate",
    meta: indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___ar",
    path: "/ar/home/PPTXTranslate",
    meta: indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___fr",
    path: "/fr/home/PPTXTranslate",
    meta: indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___id",
    path: "/id/home/PPTXTranslate",
    meta: indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___itb",
    path: "/itb/home/PPTXTranslate",
    meta: indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-PPTXTranslate___uk",
    path: "/uk/home/PPTXTranslate",
    meta: indexOV__RmmnaQwd7F9sCIwymoucwukGkiYBox7n_0bVgY0Meta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/PPTXTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___en",
    path: "/en/home/TextTranslate",
    meta: indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___zh",
    path: "/zh/home/TextTranslate",
    meta: indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___ja",
    path: "/ja/home/TextTranslate",
    meta: indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___zh-TW",
    path: "/zh-TW/home/TextTranslate",
    meta: indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___ko",
    path: "/ko/home/TextTranslate",
    meta: indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___hi",
    path: "/hi/home/TextTranslate",
    meta: indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___de",
    path: "/de/home/TextTranslate",
    meta: indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___ar",
    path: "/ar/home/TextTranslate",
    meta: indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___fr",
    path: "/fr/home/TextTranslate",
    meta: indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___id",
    path: "/id/home/TextTranslate",
    meta: indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___itb",
    path: "/itb/home/TextTranslate",
    meta: indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-TextTranslate___uk",
    path: "/uk/home/TextTranslate",
    meta: indexKCmZV3Gk_458BFOgWIuwTZHwcztHS5vM88ARfhorFhBgIMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/TextTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___en",
    path: "/en/home/WordTranslate",
    meta: indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___zh",
    path: "/zh/home/WordTranslate",
    meta: indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___ja",
    path: "/ja/home/WordTranslate",
    meta: indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___zh-TW",
    path: "/zh-TW/home/WordTranslate",
    meta: indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___ko",
    path: "/ko/home/WordTranslate",
    meta: indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___hi",
    path: "/hi/home/WordTranslate",
    meta: indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___de",
    path: "/de/home/WordTranslate",
    meta: indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___ar",
    path: "/ar/home/WordTranslate",
    meta: indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___fr",
    path: "/fr/home/WordTranslate",
    meta: indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___id",
    path: "/id/home/WordTranslate",
    meta: indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___itb",
    path: "/itb/home/WordTranslate",
    meta: indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-WordTranslate___uk",
    path: "/uk/home/WordTranslate",
    meta: indexy3ZJgpRs9P_tidoqIuR8sqFpFqXryUyKtgjcHI_45UyYkMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/WordTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___en",
    path: "/en/home/ExcelTranslate",
    meta: indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___zh",
    path: "/zh/home/ExcelTranslate",
    meta: indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___ja",
    path: "/ja/home/ExcelTranslate",
    meta: indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___zh-TW",
    path: "/zh-TW/home/ExcelTranslate",
    meta: indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___ko",
    path: "/ko/home/ExcelTranslate",
    meta: indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___hi",
    path: "/hi/home/ExcelTranslate",
    meta: indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___de",
    path: "/de/home/ExcelTranslate",
    meta: indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___ar",
    path: "/ar/home/ExcelTranslate",
    meta: indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___fr",
    path: "/fr/home/ExcelTranslate",
    meta: indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___id",
    path: "/id/home/ExcelTranslate",
    meta: indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___itb",
    path: "/itb/home/ExcelTranslate",
    meta: indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ExcelTranslate___uk",
    path: "/uk/home/ExcelTranslate",
    meta: indexrjCxnAquoTt7omokdM1Nnuyo53Hirw2ZcYb4qdvwV3AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ExcelTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___en",
    path: "/en/home/ImageTranslate",
    meta: indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___zh",
    path: "/zh/home/ImageTranslate",
    meta: indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___ja",
    path: "/ja/home/ImageTranslate",
    meta: indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___zh-TW",
    path: "/zh-TW/home/ImageTranslate",
    meta: indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___ko",
    path: "/ko/home/ImageTranslate",
    meta: indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___hi",
    path: "/hi/home/ImageTranslate",
    meta: indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___de",
    path: "/de/home/ImageTranslate",
    meta: indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___ar",
    path: "/ar/home/ImageTranslate",
    meta: indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___fr",
    path: "/fr/home/ImageTranslate",
    meta: indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___id",
    path: "/id/home/ImageTranslate",
    meta: indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___itb",
    path: "/itb/home/ImageTranslate",
    meta: indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "home-ImageTranslate___uk",
    path: "/uk/home/ImageTranslate",
    meta: indexH_p88m_45JFF5law099Bms8tHT4moPbZhUgQSXaEdag7AMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/home/ImageTranslate/index.vue")
  },
  {
    name: "account-pay-payCancel___en",
    path: "/en/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___zh",
    path: "/zh/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___ja",
    path: "/ja/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___zh-TW",
    path: "/zh-TW/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___ko",
    path: "/ko/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___hi",
    path: "/hi/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___de",
    path: "/de/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___ar",
    path: "/ar/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___fr",
    path: "/fr/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___id",
    path: "/id/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___itb",
    path: "/itb/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payCancel___uk",
    path: "/uk/account/pay/payCancel",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payCancel/index.vue")
  },
  {
    name: "account-pay-payResult___en",
    path: "/en/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___zh",
    path: "/zh/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___ja",
    path: "/ja/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___zh-TW",
    path: "/zh-TW/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___ko",
    path: "/ko/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___hi",
    path: "/hi/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___de",
    path: "/de/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___ar",
    path: "/ar/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___fr",
    path: "/fr/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___id",
    path: "/id/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___itb",
    path: "/itb/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payResult___uk",
    path: "/uk/account/pay/payResult",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payResult/index.vue")
  },
  {
    name: "account-pay-payStripe___en",
    path: "/en/account/pay/payStripe",
    meta: indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___zh",
    path: "/zh/account/pay/payStripe",
    meta: indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___ja",
    path: "/ja/account/pay/payStripe",
    meta: indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___zh-TW",
    path: "/zh-TW/account/pay/payStripe",
    meta: indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___ko",
    path: "/ko/account/pay/payStripe",
    meta: indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___hi",
    path: "/hi/account/pay/payStripe",
    meta: indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___de",
    path: "/de/account/pay/payStripe",
    meta: indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___ar",
    path: "/ar/account/pay/payStripe",
    meta: indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___fr",
    path: "/fr/account/pay/payStripe",
    meta: indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___id",
    path: "/id/account/pay/payStripe",
    meta: indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___itb",
    path: "/itb/account/pay/payStripe",
    meta: indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-pay-payStripe___uk",
    path: "/uk/account/pay/payStripe",
    meta: indexPMYxGdNYikJ7eoyLg7pYZirNRJCUMDWBwAruxLFdOYcMeta || {},
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/pay/payStripe/index.vue")
  },
  {
    name: "account-privacyAgreement___en",
    path: "/en/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___zh",
    path: "/zh/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___ja",
    path: "/ja/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___zh-TW",
    path: "/zh-TW/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___ko",
    path: "/ko/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___hi",
    path: "/hi/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___de",
    path: "/de/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___ar",
    path: "/ar/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___fr",
    path: "/fr/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___id",
    path: "/id/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___itb",
    path: "/itb/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue")
  },
  {
    name: "account-privacyAgreement___uk",
    path: "/uk/account/privacyAgreement",
    component: () => import("/var/jenkins_home/workspace/pdf_web_biz_cn/pages/account/privacyAgreement/index.vue")
  },
  {
    name: component_45stubiiiJrQBLGxxGHDOi66Il30kHzvpvzbDFFkCVYpVjKWgMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubiiiJrQBLGxxGHDOi66Il30kHzvpvzbDFFkCVYpVjKWg
  }
]